/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './user-fieldset.scss';

/* eslint-disable import/no-unresolved, import/default */

import userFieldsetTemplate from './user-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function UserDirective($compile, $templateCache, $stateParams, $rootScope, $translate, types, userService, tkDialogs) {
    var linker = function (scope, element) {
        var template = $templateCache.get(userFieldsetTemplate);
        element.html(template);
        scope.authorities = [];
        scope.types = types;
        scope.stateProviderId = $stateParams.providerId;
        scope.stateCustomerId = $stateParams.customerId;
        scope.stateSubCustomerId = $stateParams.subCustomerId;

        scope.$watch('user', (newVal, prevVal) => {
            if (!scope.authorities.length || (newVal && (!prevVal || !angular.equals(newVal.id, prevVal.id)))) {
                scope.authorities = getAuthorities(scope.userScope, scope.user);
            }
        }, true);

        function getAuthorities(userScope, user) {
            var authorities = [];
            var userId = user ? user.id : null;
            if (userId) {
                var currentUserScope = types.authority[user.authority].scope;
                for (var a in types.authority) {
                    if (types.authority[a].scope == currentUserScope) {
                        authorities.push(types.authority[a]);
                    }
                }
                return authorities;
            } else {
                switch(userScope) {
                    case types.scope.system:
                        authorities.push(types.authority.SYS_ADMIN);
                        authorities.push(types.authority.SYS_USER);
                        authorities.push(types.authority.PROVIDER_ADMIN);
                        authorities.push(types.authority.PROVIDER_USER);
                        break;
                    case types.scope.provider:
                        authorities.push(types.authority.PROVIDER_ADMIN);
                        authorities.push(types.authority.PROVIDER_USER);
                        if (!scope.stateProviderId) {
                            authorities.push(types.authority.CUSTOMER_ADMIN);
                            authorities.push(types.authority.CUSTOMER_USER);
                        }
                        break;
                    case types.scope.customer:
                        authorities.push(types.authority.CUSTOMER_ADMIN);
                        authorities.push(types.authority.CUSTOMER_USER);
                        if (!scope.stateCustomerId) {
                            authorities.push(types.authority.SUB_CUSTOMER_ADMIN);
                            authorities.push(types.authority.SUB_CUSTOMER_USER);
                        }
                        break;
                    case types.scope.subCustomer:
                        authorities.push(types.authority.SUB_CUSTOMER_ADMIN);
                        authorities.push(types.authority.SUB_CUSTOMER_USER);
                        break;
                }
                return authorities;
            }
        }

        scope.disableUser = function($event, user) {
                var title = $translate.instant('user.disable-user-title', {userName: user.name});
                var content = $translate.instant('user.disable-user-text');
                var label = $translate.instant('user.disable-user');
                tkDialogs.confirm($event, title, content, label).then(
                    () => {
                        user.disabled = true;
                        userService.saveUser(user).then(
                            () => {
                                $rootScope.$broadcast('reloadEntityDetails');
                                $rootScope.$broadcast('entityUpdated', scope.user);
                            }
                        );
                    }
                );
            }

        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            userScope: '=',
            user: '=',
            isEdit: '=',
            isReadOnly: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/user/user.directive.js